import { useEffect, useState } from 'react';
import { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';
import { FormatDate } from '../../utils/Tools';

interface IErrorData {
  HasError?: boolean;
  Message?: string;
  Type?: string;
  UtcNow?: string;
}

/**
 * Replaces error.aspx and Error/Default.aspx.
 * Loads last session error when present; otherwise shows generic message.
 */
const SystemErrorPage = () => {
  const [message, setMessage] = useState<string | null>(null);
  const [utc, setUtc] = useState<string>('');
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    store.server
      .postApi<ServerResponse<IErrorData>>('../Error/Data', {})
      .then((x) => {
        if (x.Success && x.Value) {
          if (x.Value.HasError && x.Value.Message) {
            setMessage(x.Value.Message);
          }
          if (x.Value.UtcNow) {
            setUtc(FormatDate(x.Value.UtcNow as any, 'date-time') || String(x.Value.UtcNow));
          }
        }
      })
      .finally(() => setLoaded(true));
  }, []);

  return (
    <div className="main-body-page grow" data-testid="system-error-page">
      <div className="text-center" style={{ padding: '40px 20px' }}>
        <h2>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;
          {message ? "We're Sorry!" : 'Oops! An Error Has Occurred...'}
        </h2>
        {message ? (
          <>
            <p>There has been a system error!</p>
            <p className="ErrorDetails" data-testid="system-error-message">
              {message}
            </p>
          </>
        ) : (
          loaded && (
            <p data-testid="system-error-generic">
              Please try again and if this error message persists, try closing your browser and opening it again. If
              this fails please notify support.
            </p>
          )
        )}
        {utc && (
          <p className="text-muted" data-testid="system-error-time">
            Error At: {utc} UTC
          </p>
        )}
      </div>
    </div>
  );
};

export default SystemErrorPage;
